import { Button, Spinner, Tag } from "@ttc3k/trekker";
import {
  EnumOwnerType,
  EnumTagEntityTypes,
  EnumTagGroupKey,
  EnumTagGroupType,
  TagManyQuery,
  useTagGroupOneQuery,
  useTagManyQuery,
} from "gql/generated";
import { Dispatch, SetStateAction, useState } from "react";
import { getMultilingualString } from "shared/utils";
import { Center, Flex } from "styled-system/jsx";
import { CreateEditBackOfficeTagModal } from "./CreateEditBackOfficeTagModal";
import _ from "lodash";
import { useParams } from "react-router-dom";

type OrganizationBackOfficeTagsProps = {
  setIsTagModalOpen: Dispatch<SetStateAction<boolean>>;
  isTagModalOpen: boolean;
  tagVisual: "accent.magenta" | "accent.purple";
};

export const OrganizationBackOfficeTags = ({
  isTagModalOpen,
  setIsTagModalOpen,
  tagVisual,
}: OrganizationBackOfficeTagsProps) => {
  const { organizationId } = useParams();

  const {
    data: tagGroup,
    loading: tagGroupLoading,
    error: tagGroupError,
  } = useTagGroupOneQuery({
    variables: {
      filter: {
        type: EnumTagGroupType.OrganizationSpecific,
        key: EnumTagGroupKey.BackOffice,
      },
    },
  });
  const {
    data: tagData,
    loading: tagLoading,
    error: tagError,
  } = useTagManyQuery({
    variables: {
      filter: {
        tagGroup: tagGroup?.tagGroupOne?._id
          ? [tagGroup.tagGroupOne._id]
          : null,
        owner: { entityId: organizationId, type: EnumOwnerType.Organization },
        entityTypes: [EnumTagEntityTypes.Operator, EnumTagEntityTypes.Event],
      },
      limit: 10000,
    },
  });

  const [editingTag, setEditingTag] = useState<
    TagManyQuery["tagMany"][0] | null
  >(null);

  if (tagError || tagGroupError) {
    throw new Error("Error loading tags or tag group");
  }

  return (
    <>
      <Flex gap={"100"} flexWrap={"wrap"} w={"full"}>
        {tagGroupLoading || tagLoading ? (
          <Center w={"full"}>
            <Spinner w={"40px"} h={"40px"} />
          </Center>
        ) : (
          <>
            {_.sortBy(tagData?.tagMany, (tag) =>
              getMultilingualString(tag.name),
            ).map((tag) => (
              <Button
                key={tag._id}
                visual={"unstyled"}
                onClick={() => {
                  setIsTagModalOpen(true);
                  setEditingTag(tag);
                }}
              >
                <Tag visual={tagVisual} mode={"light"}>
                  {getMultilingualString(tag.name)}
                </Tag>
              </Button>
            ))}
          </>
        )}
      </Flex>
      <CreateEditBackOfficeTagModal
        isOpen={isTagModalOpen}
        onClose={() => {
          setIsTagModalOpen(false);
          setEditingTag(null);
        }}
        tag={editingTag}
        organizationId={organizationId}
        tagGroupId={tagGroup?.tagGroupOne?._id}
      />
    </>
  );
};
